export default {
  mutations: {
    SET_USERS: 'SET_USERS',
    SET_SINGLE_USER: 'SET_SINGLE_USER',
    SET_USER_BALANCE: 'SET_USER_BALANCE',
  },
  getters: {
    GET_USERS: 'GET_USERS',
    GET_SINGLE_USER: 'GET_SINGLE_USER',
    GET_USER_BALANCE: 'GET_USER_BALANCE',
  },
  actions: {
    USERS_LIST: 'USERS_LIST',
    SINGLE_USER: 'SINGLE_USER',
    USER_BALANCE: 'USER_BALANCE',
  },
};
